module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-10 col-lg-offset-1"
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.name),
      expression: "config.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Application name",
      "disabled": _vm.isEdit
    },
    domProps: {
      "value": (_vm.config.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.config.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.description),
      expression: "config.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "description",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.config.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.config.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.type),
      expression: "config.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.config.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select app type--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "screening"
    }
  }, [_vm._v("Screening")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "others"
    }
  }, [_vm._v("Others")])])]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br'), _vm._v(" "), _c('app-new-stage', {
    attrs: {
      "stageDetails": _vm.stageToEdit,
      "allApps": _vm.allApps,
      "isScreening": _vm.config.type === 'screening'
    },
    on: {
      "addStage": _vm.addStage,
      "remove": _vm.deleteStage
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('all-stages', {
    attrs: {
      "stages": _vm.stages
    },
    on: {
      "remove": _vm.deleteStage,
      "edit": _vm.editStage
    }
  }), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), (_vm.preview) ? _c('preview', {
    attrs: {
      "config": _vm.config
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "disabled": !_vm.actionable,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "disabled": !_vm.actionable,
      "type": "button"
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("Generate JSON")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "disabled": !_vm.actionable,
      "type": "button"
    },
    on: {
      "click": _vm.deploy
    }
  }, [_vm._v("Deploy")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "disabled": !_vm.actionable,
      "type": "button"
    },
    on: {
      "click": _vm.togglePreview
    }
  }, [_vm._v(_vm._s(_vm.previewText))])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      GENERIC SMS APP\n      "), _c('small', [_vm._v("Create An SMS Application")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create SMS Application")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e2c21cae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateSmsApp/index.vue
// module id = R9ho
// module chunks = 1